import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Events, AlertController, LoadingController, NavController, NavParams, ModalController, ToastController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { Storage } from '@ionic/storage';
import { UpiManualPaymentPage } from "../pages/upi-manual-payment/upi-manual-payment.page";
import { ConfigService } from '../services/config/config.service';
import { LabelService } from 'src/app/services/label/label.service';
import { CouponCodesService } from '../services/coupon-codes/coupon-codes.service';
import { UserService } from '../services/user/user.service';
import { CartService } from '../services/cart/cart.service';
import { CustomPaymentOptionPage } from '../pages/custom-payment-option/custom-payment-option.page';
import { AdminSettingsService } from '../services/admin-settings/admin-settings.service';
import { StripePage } from '../pages/payment-ui/stripe/stripe.page';
import { PaypalPage } from '../pages/payment-ui/paypal/paypal.page';
import { OrderService } from '../services/order/order.service';
import { SharedService } from '../services/shared/shared.service';
var OrderPaymentPage = /** @class */ (function () {
    function OrderPaymentPage(events, router, alertController, loadingController, route, storage, navParams, modalController, navCtrl, labelService, configService, toastController, couponCodesService, cartService, userService, adminSettingsService, orderService, sharedService) {
        this.events = events;
        this.router = router;
        this.alertController = alertController;
        this.loadingController = loadingController;
        this.route = route;
        this.storage = storage;
        this.navParams = navParams;
        this.modalController = modalController;
        this.navCtrl = navCtrl;
        this.labelService = labelService;
        this.configService = configService;
        this.toastController = toastController;
        this.couponCodesService = couponCodesService;
        this.cartService = cartService;
        this.userService = userService;
        this.adminSettingsService = adminSettingsService;
        this.orderService = orderService;
        this.sharedService = sharedService;
        this.phonepeNo = '';
        this.paytmNo = '';
        this.upiId = '';
        this.showLoader = true;
        this.totalPriceAfterDiscount = 0;
        this.paytmActive = false;
        this.razorpayActive = false;
        this.walletActive = true;
        this.minOrderAmntToUseWallet = 0;
        this.maxWalletAmntPerOrder = 1000;
        this.walletUsed = false;
        this.walletAmount = 0;
        this.envPaytmActive = false;
        this.cashbackAmount = 0;
        this.cashbackBalance = 0;
        this.upiManual = {
            active: false,
            upiId: '',
            qrCode: ''
        };
        this.isCod = false;
        this.SHARED_LABELS = {};
        this.ORDER_PAYMENT_LABELS = {};
        this.isCodAvailableForCoupon = true;
        this.codPercent = 100;
        this.partialPayment = {
            status: false,
            cod: 0,
            online: {
                amount: 0,
                completed: false
            }
        };
        this.paymentType = 'full'; // value: full || partial
        this.customOption = {
            active: false,
            name: '',
            details: '',
            image: {
                url: ''
            },
            textMandatory: false,
            imageMandatory: false
        };
        this.stripeData = {
            active: false
        };
        this.paymentGateways = ['paypal', 'cashfree'];
        this.paypalObj = {
            active: false
        };
        this.cashfreeObj = {
            active: false
        };
        this.ccAvenueObj = {
            active: false
        };
        this.extraCharge = {
            cash: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            razorpay: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            paytm: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            stripe: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            paypal: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            cashfree: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
            ccAvenue: { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 },
        };
        var orderId = navParams.get('orderId');
        var userId = navParams.get('userId');
        if (orderId !== undefined && userId !== undefined) {
            this.orderId = orderId;
            this.userId = userId;
        }
    }
    OrderPaymentPage.prototype.ngOnInit = function () {
        this.currencyCode = this.configService.environment.currencyCode;
        this.taxType = this.configService.environment.taxType;
    };
    OrderPaymentPage.prototype.ionViewDidEnter = function () {
        //this.envPaytmActive = environment.envPaytmActive;
        this.events.publish('user:getOrderDetailsWithOrderId', this.orderId);
        this.events.publish('wallet:getUserWalletDetails', this.userId);
        this.events.publish('wallet:getWalletSettings');
        this.initializeSubscriptions();
        this.SHARED_LABELS = this.labelService.labels['SHARED'];
        this.ORDER_PAYMENT_LABELS = this.labelService.labels['ORDER_PAYMENT'];
        this.getStripeDetails();
        this.getGateways();
        this.fetchIntegrationsCred();
    };
    OrderPaymentPage.prototype.ionViewWillLeave = function () {
        this.removeSubscription();
    };
    OrderPaymentPage.prototype.fetchIntegrationsCred = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var integrationRes, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.orderService.getIntegrationsCred('CCAvenue')];
                    case 1:
                        integrationRes = _a.sent();
                        console.log('integrationRes CCAvenue', integrationRes);
                        if (Object.keys(integrationRes.credentials).length) {
                            this.ccAvenueObj = integrationRes;
                            this.ccAvenueObj['active'] = true;
                        }
                        else {
                            this.ccAvenueObj['active'] = false;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.ccAvenueObj['active'] = false;
                        console.error('fetchIntegrationsCred error', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.initializeSubscriptions = function () {
        var _this = this;
        this.events.subscribe('admin-settings:publishPaymentInfoData', function (data) {
            var isCod = typeof data.isCod !== 'undefined' ? data.isCod : true;
            var extraNoCodChecks = false;
            if (isCod) {
                for (var _i = 0, _a = _this.orderData[0].products; _i < _a.length; _i++) {
                    var pdt = _a[_i];
                    if (pdt.hasOwnProperty('orderType') && pdt.orderType === 'membership' || ('isCod' in pdt && !pdt.isCod)) {
                        extraNoCodChecks = true;
                        break;
                    }
                }
            }
            if (extraNoCodChecks || !_this.isCodAvailableForCoupon) {
                isCod = false;
            }
            _this.isCod = isCod;
            _this.upiManual = data.hasOwnProperty('upiManual') ? data.upiManual : _this.upiManual;
            _this.codPercent = 'codPercentage' in data ? data.codPercentage : 100;
            _this.partialPayment.status = _this.codPercent < 100 ? true : false;
            _this.customOption = 'custom' in data ? data.custom : _this.customOption;
            _this.extraCharge.cash = 'extraCharge' in data ? data.extraCharge : _this.getInitObjForExtraCharge();
            _this.isGstApplicable = 'isGstApplicable' in data ? data.isGstApplicable : false;
        });
        this.events.subscribe('user:publishOrderDetailsWithOrderId', function (orderData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.orderData = orderData;
                        if (!this.orderData[0].couponId) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.couponCodesService.checkCODAvailabilityOfCoupon(this.orderData[0].couponId)];
                    case 1:
                        _a.isCodAvailableForCoupon = _b.sent();
                        _b.label = 2;
                    case 2:
                        if ('extraChargeOnPayment' in this.orderData && this.orderData[0].extraChargeOnPayment.charge) {
                            this.orderData[0].extraChargeOnPayment = { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 };
                        }
                        this.events.publish('admin-settings:getPaytmData');
                        this.events.publish('admin-settings:getRazorPayData');
                        this.events.publish('admin-settings:getPaymentInfoData');
                        this.showLoader = false;
                        return [2 /*return*/];
                }
            });
        }); });
        this.events.subscribe('user:setPaymentModeOfOrderByUserSuccessfully', function () {
            _this.loading.dismiss();
            _this.presentAlert("" + _this.ORDER_PAYMENT_LABELS['payment_mode_set_msg']);
        });
        this.events.subscribe('admin-settings:publishPaytmData', function (data) {
            if (data) {
                _this.paytmActive = false;
                _this.extraCharge.paytm = 'extraChargePaytm' in data ? data.extraChargePaytm : _this.getInitObjForExtraCharge();
            }
        });
        this.events.subscribe('admin-settings:publishRazorPayData', function (data) {
            if (data && data.active && data.id !== '') {
                _this.razorpayActive = data.active;
                _this.razorpayId = data.id;
                _this.extraCharge.razorpay = 'extraChargeRazorpay' in data ? data.extraChargeRazorpay : _this.getInitObjForExtraCharge();
            }
        });
        this.events.subscribe('order:modeSetToCashSuccess', function () {
            _this.loading.dismiss();
            _this.presentAlert("" + _this.ORDER_PAYMENT_LABELS['payment_mode_to_cash_msg']);
            _this.modalDismiss();
        });
        this.events.subscribe('order:completePaymentWithWalletSuccess', function () {
            _this.loading.dismiss();
            _this.presentAlert("" + _this.ORDER_PAYMENT_LABELS['payment_is_successful']);
        });
        this.events.subscribe('wallet:publishUserWalletDetails', function (data) {
            if (data) {
                _this.walletBalance = data.wallet ? data.wallet.balance : 0;
                _this.cashbackBalance = data.wallet && data.wallet.cashback && data.wallet.cashback > 0 ? data.wallet.cashback : 0;
            }
        });
        this.events.subscribe('wallet:publishWalletSettings', function (data) {
            if (!_this.isEmptyObj(data)) {
                _this.walletActive = typeof data.active !== 'undefined' ? data.active : true;
                _this.minOrderAmntToUseWallet = data.minOrderAmnt ? data.minOrderAmnt : 0;
                _this.maxWalletAmntPerOrder = data.maxWalletAmntPerOrder ? data.maxWalletAmntPerOrder : 1000;
            }
        });
    };
    OrderPaymentPage.prototype.completePaymentWithWallet = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alertRes, valid;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.presentAlertConfirm(this.SHARED_LABELS['payment_mode_alert_msg'])];
                    case 1:
                        alertRes = _a.sent();
                        if (!alertRes) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkOrderUpdation()];
                    case 2:
                        valid = _a.sent();
                        if (!valid) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.presentLoading(1000000)];
                    case 3:
                        _a.sent();
                        this.orderData[0]['walletAmount'] = this.walletAmount;
                        this.orderData[0]['cashbackAmount'] = this.cashbackAmount;
                        this.events.publish('order:completePaymentWithWallet', this.orderData[0]);
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.isEmptyObj = function (object) {
        for (var key in object) {
            if (object.hasOwnProperty(key))
                return false;
        }
        return true;
    };
    OrderPaymentPage.prototype.onClickUseWallet = function () {
        if (this.walletUsed) {
            this.walletUsed = false;
            this.walletAmount = 0;
            this.cashbackAmount = 0;
        }
        else {
            this.getUsableWalletAmnt();
            this.walletUsed = true;
        }
    };
    OrderPaymentPage.prototype.presentToast = function (msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toast;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.toastController.create({
                            message: msg,
                            duration: 2000,
                        })];
                    case 1:
                        toast = _a.sent();
                        toast.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.getUsableWalletAmnt = function () {
        var walletUsed = 0;
        var cashbackUsed = 0;
        if (this.orderData[0].totalAmountToPaid < this.minOrderAmntToUseWallet) {
            walletUsed = this.orderData[0].totalAmountToPaid >= this.walletBalance ? this.walletBalance : this.orderData[0].totalAmountToPaid;
            this.walletAmount = walletUsed;
        }
        else {
            cashbackUsed = this.orderData[0].totalAmountToPaid >= this.cashbackBalance ? this.cashbackBalance : this.orderData[0].totalAmountToPaid;
            cashbackUsed = cashbackUsed > this.maxWalletAmntPerOrder ? this.maxWalletAmntPerOrder : cashbackUsed;
            this.cashbackAmount = cashbackUsed;
            if (this.orderData[0].totalAmountToPaid - this.cashbackAmount > 0) {
                walletUsed = (this.orderData[0].totalAmountToPaid - this.cashbackAmount) >= this.walletBalance ? this.walletBalance : (this.orderData[0].totalAmountToPaid - this.cashbackAmount);
                this.walletAmount = walletUsed;
            }
        }
    };
    OrderPaymentPage.prototype.getTotalItems = function () {
        return this.orderData[0].products.length;
    };
    OrderPaymentPage.prototype.modalDismiss = function () {
        this.modalController.dismiss();
    };
    OrderPaymentPage.prototype.onClickPaymentMode = function (mode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alertRes, valid;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.presentAlertConfirm(this.SHARED_LABELS['payment_mode_alert_msg'])];
                    case 1:
                        alertRes = _a.sent();
                        if (!alertRes) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkOrderUpdation()];
                    case 2:
                        valid = _a.sent();
                        if (!valid) {
                            return [2 /*return*/];
                        }
                        this.checkPartialPayment();
                        this.orderData[0]['walletAmount'] = this.walletAmount;
                        this.orderData[0]['cashbackAmount'] = this.cashbackAmount;
                        if (!(mode === 'cash')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.presentLoading(10000)];
                    case 3:
                        _a.sent();
                        this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.cash);
                        this.events.publish('order:payWithCash', this.orderData[0]);
                        _a.label = 4;
                    case 4:
                        if (!(mode === 'card' || mode === 'wallet' || mode === 'upi' || mode === 'netbanking')) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.presentLoading(10000)];
                    case 5:
                        _a.sent();
                        this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.razorpay);
                        this.events.publish('order:payWithRazorPay', this.orderData[0], this.razorpayId, mode);
                        this.modalDismiss();
                        _a.label = 6;
                    case 6:
                        if (!(mode === 'paytm')) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.presentLoading()];
                    case 7:
                        _a.sent();
                        this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.paytm);
                        this.events.publish('order:payWithPaytm', this.orderData[0].orderId, this.userId, this.orderData[0].totalAmountToPaid);
                        this.modalDismiss();
                        _a.label = 8;
                    case 8:
                        if (mode === 'upiManual') {
                            this.modalDismiss();
                            this.presentUPIModal(this.orderData[0], this.upiManual);
                        }
                        if (mode === 'custom') {
                            this.modalDismiss();
                            this.presentCustomOptionModal();
                        }
                        if (mode === 'stripe') {
                            this.modalDismiss();
                            this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.stripe);
                            this.presentStripeModal();
                        }
                        if (mode === 'paypal') {
                            this.modalDismiss();
                            this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.paypal);
                            this.presentPaypalModal();
                        }
                        if (mode === 'cashfree') {
                            this.modalDismiss();
                            this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.cashfree);
                            this.payWithCashfree();
                        }
                        if (!(mode === 'ccAvenue')) return [3 /*break*/, 11];
                        this.orderData['extraChargeOnPayment'] = this.getExtraChargeAmount(this.extraCharge.ccAvenue);
                        if (!!this.ccAvenueObj.paymentPage) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.sharedService.presentAlert('Payment link not found, please contact support!')];
                    case 9:
                        _a.sent();
                        return [2 /*return*/];
                    case 10:
                        this.orderService.openCCAvenuePortal(this.orderData[0], this.ccAvenueObj.paymentPage, this.orderId);
                        _a.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.getExtraChargeAmount = function (extraChargeObj) {
        var extraCharge = 0;
        extraChargeObj = this.paymentType === 'partial' ? this.extraCharge.cash : extraChargeObj;
        if (Object.keys('extraChargeObj').length && extraChargeObj.charge) {
            if (extraChargeObj.type === 'flat') {
                extraCharge = extraChargeObj.charge;
            }
            else {
                extraCharge = (this.orderData[0].totalAmountToPaid - (this.orderData[0].walletAmount + this.orderData[0].cashbackAmount)) * (extraChargeObj.charge / 100);
                if (extraCharge > extraChargeObj.maxCharge) {
                    extraCharge = extraChargeObj.maxCharge;
                }
            }
            this.orderData[0].totalAmountToPaid += extraCharge;
            this.calcGst(extraCharge);
        }
        return { charge: extraCharge, name: extraChargeObj.chargeName || '' };
    };
    OrderPaymentPage.prototype.calcGst = function (extraCharge) {
        var _this = this;
        var allGst = [];
        var gstOnExtraCharge = 0;
        this.orderData[0].products.map(function (p) {
            if (p.gst && _this.isGstApplicable) {
                allGst.push(p.gst);
            }
        });
        if (allGst.length) {
            var minGst = 0;
            minGst = Math.min.apply(Math, allGst);
            gstOnExtraCharge = (extraCharge - (extraCharge / (1 + (minGst / 100))));
            this.orderData[0].defaultGst += gstOnExtraCharge;
            this.orderData[0].deliveryGstObj.extraChargeGst = (this.orderData[0].deliveryGstObj.extraChargeGst || 0) + gstOnExtraCharge;
        }
    };
    OrderPaymentPage.prototype.presentUPIModal = function (order, upiManual) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: UpiManualPaymentPage,
                            cssClass: 'custom-modal',
                            componentProps: {
                                order: order,
                                upiManual: upiManual
                            }
                        })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentCustomOptionModal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: CustomPaymentOptionPage,
                            cssClass: 'custom-modal',
                            componentProps: {
                                order: this.orderData,
                                customOption: this.customOption
                            }
                        })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentAlert = function (msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            message: msg,
                            buttons: [{
                                    text: this.SHARED_LABELS['ok'],
                                    handler: function () {
                                        _this.navCtrl.navigateRoot(['/']);
                                    }
                                }]
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentLoading = function (duration) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loadingController.create({
                                message: this.SHARED_LABELS['please_wait'],
                                duration: duration ? duration : 5000
                            })];
                    case 1:
                        _a.loading = _b.sent();
                        return [4 /*yield*/, this.loading.present()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentFailureAlert = function (msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var alert;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            message: msg,
                            buttons: ["" + this.ORDER_PAYMENT_LABELS['try_again']]
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.showUnavailablePrice = function () {
        if (this.orderData[0].unavailablePrice && (this.orderData[0].hasOwnProperty('autoConfirmOrder') && (!this.orderData[0].autoConfirmOrder || (this.orderData[0].autoConfirmOrder && !this.orderData[0].payment.completed)))) {
            return true;
        }
        else {
            return false;
        }
    };
    OrderPaymentPage.prototype.checkPartialPayment = function () {
        var partial = tslib_1.__assign({}, this.partialPayment);
        if (this.paymentType === 'partial') {
            partial.status = true;
        }
        else {
            partial.status = false;
        }
        this.orderData[0]['partialPayment'] = partial;
    };
    OrderPaymentPage.prototype.setPaymentType = function (type) {
        this.paymentType = type;
        if (type === 'partial') {
            this.partialPayment['cod'] = parseFloat((this.getFinalAmount() * (this.codPercent / 100)).toFixed(2));
            this.partialPayment['online']['amount'] = parseFloat((this.getFinalAmount() - this.partialPayment['cod']).toFixed(2));
        }
    };
    OrderPaymentPage.prototype.getFinalAmount = function () {
        return this.orderData[0].totalAmountToPaid - (this.walletAmount + this.cashbackAmount);
    };
    OrderPaymentPage.prototype.checkOrderUpdation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isProductsUpdated, isQtyAvailable;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.presentLoading(1000000000)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.cartService.compareCartWithUpdatedCart(this.orderData[0].products, 'order-summary')];
                    case 2:
                        isProductsUpdated = (_a.sent()).cartUpdated;
                        isQtyAvailable = true;
                        if (!!isProductsUpdated) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.cartService.inventoryManagement({ products: this.orderData[0].products, orderId: this.orderData[0].id })];
                    case 3:
                        isQtyAvailable = _a.sent();
                        if (isQtyAvailable) {
                            this.loading.dismiss();
                            return [2 /*return*/, true];
                        }
                        _a.label = 4;
                    case 4:
                        if (!(isProductsUpdated || !isQtyAvailable)) return [3 /*break*/, 6];
                        this.loading.dismiss();
                        return [4 /*yield*/, this.cancelOrderAlert()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.cancelOrderAlert = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var alert;
                        var _this = this;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.alertController.create({
                                        message: this.ORDER_PAYMENT_LABELS['cart_updated_alert'],
                                        buttons: [{
                                                text: this.ORDER_PAYMENT_LABELS['cancel_and_create_new'],
                                                handler: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                    var _i, _a, product;
                                                    return tslib_1.__generator(this, function (_b) {
                                                        switch (_b.label) {
                                                            case 0: return [4 /*yield*/, this.presentLoading()];
                                                            case 1:
                                                                _b.sent();
                                                                return [4 /*yield*/, this.userService.cancelOrderByUser(this.orderData[0].orderId, this.ORDER_PAYMENT_LABELS['cancelled_reason'], 'return')];
                                                            case 2:
                                                                _b.sent();
                                                                _i = 0, _a = this.orderData[0].products;
                                                                _b.label = 3;
                                                            case 3:
                                                                if (!(_i < _a.length)) return [3 /*break*/, 6];
                                                                product = _a[_i];
                                                                return [4 /*yield*/, this.cartService.addProductToCart(product)];
                                                            case 4:
                                                                _b.sent();
                                                                _b.label = 5;
                                                            case 5:
                                                                _i++;
                                                                return [3 /*break*/, 3];
                                                            case 6:
                                                                this.loading.dismiss();
                                                                this.modalDismiss();
                                                                this.router.navigate(['user-cart']);
                                                                resolve(true);
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }
                                            }, {
                                                text: this.ORDER_PAYMENT_LABELS['cancel_order'],
                                                handler: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                    return tslib_1.__generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, this.userService.cancelOrderByUser(this.orderData[0].orderId, this.ORDER_PAYMENT_LABELS['cancelled_reason'], 'return')];
                                                            case 1:
                                                                _a.sent();
                                                                this.modalDismiss();
                                                                this.navCtrl.navigateRoot(['tabs/tabs/user-order-history']);
                                                                resolve(true);
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); }
                                            }]
                                    })];
                                case 1:
                                    alert = _a.sent();
                                    return [4 /*yield*/, alert.present()];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    OrderPaymentPage.prototype.getStripeDetails = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.adminSettingsService.getStripeData()];
                    case 1:
                        _a.stripeData = _b.sent();
                        this.extraCharge.stripe = 'extraChargeStripe' in this.stripeData ? this.stripeData.extraChargeStripe : this.getInitObjForExtraCharge();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentStripeModal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: StripePage,
                            cssClass: 'custom-modal',
                            componentProps: {
                                orderData: this.orderData[0],
                                stripeData: this.stripeData,
                                autoConfirm: false
                            }
                        })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.getGateways = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _i, _a, paymentGateway, paymentGatewayData;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.paymentGateways;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        paymentGateway = _a[_i];
                        return [4 /*yield*/, this.adminSettingsService.getPaymentGateway(paymentGateway)];
                    case 2:
                        paymentGatewayData = _b.sent();
                        if (paymentGatewayData && paymentGatewayData.active) {
                            if (paymentGateway == 'paypal') {
                                this.paypalObj = paymentGatewayData;
                                this.extraCharge.paypal = 'extraChargePaypal' in this.paypalObj ? this.paypalObj.extraChargePaypal : this.getInitObjForExtraCharge();
                            }
                            if (paymentGateway == 'cashfree') {
                                this.cashfreeObj = paymentGatewayData;
                                this.extraCharge.cashfree = 'extraChargeCashfree' in this.cashfreeObj ? this.cashfreeObj.extraChargeCashfree : this.getInitObjForExtraCharge();
                            }
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.presentPaypalModal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var modal;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: PaypalPage,
                            cssClass: 'custom-modal',
                            componentProps: {
                                orderData: this.orderData[0],
                                autoConfirm: false,
                                paypalObj: this.paypalObj
                            }
                        })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.payWithCashfree = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('this.orderData:', this.orderData[0]);
                        return [4 /*yield*/, this.orderService.createOrderCashfree(this.orderData[0], false)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OrderPaymentPage.prototype.getInitObjForExtraCharge = function () {
        return { charge: 0, type: 'flat', chargeName: '', maxCharge: 0 };
    };
    OrderPaymentPage.prototype.removeSubscription = function () {
        this.events.unsubscribe('user:publishOrderDetailsWithOrderId');
        this.events.unsubscribe('user:setPaymentModeOfOrderByUserSuccessfully');
        this.events.unsubscribe('admin-settings:publishPaytmData');
        this.events.unsubscribe('admin-settings:publishRazorPayData');
        this.events.unsubscribe('order:modeSetToCashSuccess');
        this.events.unsubscribe('wallet:publishUserWalletDetails');
        this.events.unsubscribe('wallet:publishWalletSettings');
        this.events.unsubscribe('order:completePaymentWithWalletSuccess');
        this.events.unsubscribe('admin-settings:publishPaymentInfoData');
    };
    return OrderPaymentPage;
}());
export { OrderPaymentPage };
